module.exports = __webpack_public_path__ + "static/media/python.22284ad7.png";